import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'

import type { CreateReportValidateProjectionMutation } from 'generated/resources/graphql'

type ReportsValidateProjection = NonNullable<
  NonNullable<
    CreateReportValidateProjectionMutation['reportsMutations']['createReportsValidateProjection']
  >['validateProjection']
>

type ValidationContext = [
  ReportsValidateProjection,
  Dispatch<SetStateAction<ReportsValidateProjection>>
]

const validationContext = createContext<ValidationContext | undefined>(undefined)

const DEFAULT_VALUE: ReportsValidateProjection = { isValid: true, errors: { fields: [] } }

const ValidationContext: React.FC<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  const validationState = useState<ReportsValidateProjection>(DEFAULT_VALUE)

  return <validationContext.Provider value={validationState}>{children}</validationContext.Provider>
}

const useValidationContext = () => {
  const validationtate: ValidationContext | undefined = useContext(validationContext)

  if (!validationtate) {
    throw 'Invalid state'
  }

  return validationtate
}

export { ValidationContext, useValidationContext }
